






import { Component, Vue } from 'vue-property-decorator';
import AdvancedMarkerMap from '@/components/AdvancedMarkerMap.vue';

@Component({
  components: {AdvancedMarkerMap},
})
export default class NetworkMap extends Vue {
}
